import { createTheme } from '@mantine/core';

export const theme = createTheme({
  cursorType: "pointer",
  defaultRadius: "md",
  colors: {
    "blue": [
      "#e9f3ff",
      "#d3e3fb",
      "#a5c4f5",
      "#74a3f0",
      "#4c88eb",
      "#3476e9",
      "#276ee9",
      "#1a5dd0",
      "#0f52ba",
      "#0047a5"
    ]
  },
  primaryColor: "blue"
});